import styled, { css } from 'styled-components';

const LineStyle = css`
  display: block;
  position: relative;
  left: 0;
  padding-left: ${p => (p.theme.isMobile ? '15px' : '40px')};
  color: ${p => (p.theme.isMobile ? '#e7e7e7' : '#000000')};
`;

const ArrowStyle = css`
  display: block;
  content: '';
  box-sizing: border-box;
  position: absolute;
  width: 5px;
  height: 5px;
  border-right: 1px solid;
`;

export const HorizontalArrow = styled.div`
  ${LineStyle}
  border-top: 1px solid;
  width: ${p => (p.theme.isMobile ? '20px' : '25px')};
  margin-right: 1px;
  ${p =>
    p.theme.isMobile
      ? ''
      : `
    &::after {
      ${ArrowStyle}
      right: 0;
      bottom: 0.5px;
      transform: translate(0, 50%) rotate(45deg);
      border-top: 1px solid;
    }
  `};
`;

export const VerticalArrow = styled.div<{
  $length: string;
  $hasNext?: boolean;
}>`
  ${LineStyle}
  border-right: 1px solid;
  height: ${p => p.$length};
  margin-bottom: ${p => (p.$hasNext ? 'unset' : '1px')};
  ${p =>
    p.theme.isMobile
      ? ''
      : `
      &::after {
        ${ArrowStyle}
        right: -0.5px;
        bottom: 0;
        transform: translate(50%, 0) rotate(45deg);
        border-bottom: 1px solid;
        visibility: ${p.$hasNext ? 'hidden' : 'visible'};
      }
    `};
`;

export const VerticalDotLine = styled.div<{ $length: string }>`
  ${LineStyle}
  border-right: 1px dashed;
  height: ${p => p.$length};
  ${p =>
    p.theme.isMobile
      ? ''
      : `
      &::after {
        right: -0.5px;
        bottom: 0;
        transform: translate(50%, 0) rotate(45deg);
        border-bottom: 1px solid;
      }
    `};
`;
